import { useNavigate } from 'react-router-dom';
import { Button, Typography } from 'antd';

import styles from './index.module.scss';
import { IconTipping } from '../../../../Common/Icon';

export interface SendSuccessProps {
  onClose?: () => void;
}
export default function SendSuccess({ onClose }: SendSuccessProps) {
  const navigate = useNavigate();

  return (
    <>
      {/* <Typography.Title level={5} className={styles.title}>
        Please check your email
      </Typography.Title>
      <Typography.Paragraph className={styles.secondary} type="secondary">
        A reset password link has been sent to your email address.
      </Typography.Paragraph> */}
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <IconTipping />
        <h4 style={{ marginTop: '15px' }}>Please check your email</h4>
        <span style={{ fontWeight: 300 }}>
          A reset password link has been sent to your email address.
        </span>
      </div>
      <Button
        size="large"
        type="primary"
        block
        onClick={() => {
          onClose?.();
          navigate('/');
        }}
      >
        Back to log in
      </Button>
    </>
  );
}
